import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'

const Index = () => import(/* webpackChunkName: "admin/brands" */ './Index')
const Form = () => import(/* webpackChunkName: "admin/brands" */ './Form')

export default [
  {
    path: 'brands',
    name: 'brands-index',
    component: Index,
    meta: {
      auth: true,
    },
    children: [
      {
        path: 'add',
        name: 'brands-add',
        component: Form,
        meta: {
          auth: true,
        }
      },
      {
        path: ':id/edit',
        name: 'brands-edit',
        component: Form,
        meta: {
          auth: true,
        }
      }
    ]
  },

]
